import React from 'react'
import { ProductDataShape } from './ProductDataShape'

export const ProductDataContext = React.createContext<ProductDataShape>({
  interfaces: [],
  skins: [],
  mechs: [],
  grids: [],
  skinGridProducts: [],
  rules: [],
  constants: {
    WiserHub: '',
    WiserSwitchDefaultMech: '',
  },
  wallColorOptions: [],
  mechMap: { },
  interfaceMap: { },
})
